import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cancel_text" }

import { Popover } from 'vant'
import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Popover',
  emits: ['cancel'],
  setup(__props, { emit: __emit }) {

const emits = __emit

const PopoverShow = ref(false)
const onSelect = () => {
  PopoverShow.value = false
  emits('cancel')
}

const openPopover = () => {
  PopoverShow.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Popover), {
      show: PopoverShow.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((PopoverShow).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "cancel_div",
          onClick: _withModifiers(onSelect, ["stop"])
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("i", { class: "iconfont icon-icon_wodeshoucang_quxiaoshoucangsvg" }, null, -1)),
          _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('cancel_favorite')), 1)
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("i", {
      class: "iconfont text_ellipsis icon-icon_shipin_gengduo1",
      onClick: _withModifiers(openPopover, ["stop"])
    })
  ], 64))
}
}

})